module.exports = __webpack_public_path__ + "img/strike.4eda7ee9.svg";